export default __webpack_public_path__ + "static/media/sindhu.815fa97a.jpg";